<div id="course-loading" class="text-center mt-3" *ngIf="courseLoading && !courseError">
    <p>{{ courseLoadingStr }}</p>
    <i class="spinner-border text-dark"></i>
</div>

<div id="course-error" class="text-center mt-3" *ngIf="!courseLoading && courseError">
    <p class="red">
        <i class="fas fa-times me-1"></i>
        <b>ERROR: </b>
        <span>{{ courseErrorStr }}</span>
    </p>
</div>

<div id="course-lock-status" *ngIf="!courseLoading && !courseError">
    <div id="course-unlocked" class="alert alert-success alert-dismissable fade show m-3 p-3 fs-5 text-center" *ngIf="!courseLocked">
        <button type="button" class="btn-close float-end" data-bs-dismiss="alert"></button>
        <p><i class="fas fa-lock-open me-2"></i>Este curso está abierto para editar.</p>
        <p>Cuando termines y quieras que se instale en plataforma, haz clic en <strong>Herramientas -> Terminar edición y solicitar instalación.</strong></p>
    </div>
    
    <div id="course-locked" class="alert alert-warning alert-dismissable fade show m-3 p-3 fs-5 text-center" *ngIf="courseLocked">
        <button type="button" class="btn-close float-end" data-bs-dismiss="alert"></button>
        <p><i class="fas fa-lock me-2"></i>Este curso se marcó como listo para instalar en {{ courseLockedTime }}.</p>
        <p>Por lo tanto, no se pueden hacer cambios.</p>
        <p>Para realizar cambios, haz clic en <strong>Herramientas -> Solicitar permiso para editar.</strong></p>
    </div>
</div>

<div id="course-error-status" *ngIf="!courseLoading && !courseError">
    <div id="course-errors" class="alert alert-danger alert-dismissable fade show m-3 p-3 fs-5" *ngIf="courseHasErrors">
        <button type="button" class="btn-close float-end" data-bs-dismiss="alert"></button>
        <p class="text-center"><i class="fas fa-triangle-exclamation me-2"></i>Se han encontrado los siguientes problemas con este curso:</p>
        <ul class="text-left">
            <li *ngFor="let error of courseErrors">
                {{ error }}
            </li> 
        </ul>
        <p class="text-center">No se podrá generar previsualizaciones ni exportar el curso hasta que se corrijan estos problemas.</p>
    </div>

    <div id="course-no-errors" class="alert alert-success alert-dismissable fade show m-3 p-3 fs-5 text-center" *ngIf="!courseHasErrors">
        <button type="button" class="btn-close float-end" data-bs-dismiss="alert"></button>
        <span><i class="fas fa-check me-2"></i>No se han encontrado problemas en este curso.</span>
    </div>
</div>

<div id="course-job-running" class="alert alert-info alert-dismissable fade show m-3 p-3 fs-5 text-center" *ngIf="!courseLoading && !courseError && runningJob != null">
    <button type="button" class="btn-close float-end" data-bs-dismiss="alert"></button>
    <p>Se ha detectado una tarea ejecutándose para este curso:</p>
    <div *ngIf="runningJob.command == 'unit_generate'">
        <p>Generación de unidades</p>
        <p>Nombre de la unidad: {{ runningJob.data.unit_name }}</p>
    </div>
    <p>{{ runningJob.message }}</p>
    <p>Progreso: {{ runningJob.progress }}%</p>
</div>

<div id="course-container" *ngIf="!courseLoading && !courseError">
    <h1 id="course-name" class="mb-3" *ngIf="courseNameView">{{ courseNameView }}</h1>

    <button class="btn btn-primary mb-3" (click)="openCourseForm()">
        <i class="fas fa-edit"></i>
        <span>Editar</span>
    </button>

    <div id="course-translation-container" class="w-25 mb-3" *ngIf="courseMultitransl">
        <p class="fw-bold">Idioma actual:</p>
        <select id="course-translation" class="form-select" [(ngModel)]="courseCurrentTransl" (ngModelChange)="changeTranslation()">
            <option *ngFor="let transl of courseTranslations" [value]="transl">
                <span *ngIf="transl == 'es'">Español</span>
                <span *ngIf="transl == 'en'">English</span>
                <span *ngIf="transl == 'ca'">Catalá</span>
                <span *ngIf="transl == 'gl'">Galego</span>
            </option>
        </select>
    </div>

    <ul id="course-nav">
        <li id="course-actions-text" class="dropdown" *ngIf="userID == 1">
            <i class="fas fa-align-center"></i>
            <span>Acciones de texto</span>
            <ul id="course-actions-text-dropdown" class="dropdown-content">
                <li routerLink="/refactor-text/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-brain"></i>
                    <i class="fas fa-align-center"></i>
                    <span>Resumir / parafrasear texto</span>
                </li>
                <li routerLink="/merge-split-headings/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-align-center"></i>
                    <span>Unir / dividir enunciados</span>
                </li>
                <li routerLink="/suggest-title/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-brain"></i>
                    <i class="fas fa-align-center"></i>
                    <span>Recomendar títulos para enunciados</span>
                </li>
                <li routerLink="/extract-text-web/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-globe"></i>
                    <i class="fas fa-align-center"></i>
                    <span>Extraer texto de páginas web</span>
                </li>
            </ul>
        </li>
        <li id="course-actions-new-nodes" class="dropdown" *ngIf="userID == 1">
            <i class="fas fa-file-medical"></i>
            <span>Generar nuevos nodos</span>
            <ul id="course-actions-new-nodes-dropdown" class="dropdown-content">
                <li routerLink="/generate-activities-test/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-brain"></i>
                    <i class="fas fa-check-square"></i>
                    <i class="fas fa-check-circle"></i>
                    <span>Generar actividades / evaluación</span>
                </li>
                <li routerLink="/generate-glossary/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-list"></i>
                    <span>Generar glosario</span>
                </li>
            </ul>
        </li>
        <li id="course-actions-multimedia" class="dropdown" *ngIf="userID == 1">
            <i class="fas fa-photo-video"></i>
            <span>Acciones de multimedia</span>
            <ul id="course-actions-multimedia-dropdown" class="dropdown-content">
                <li routerLink="/recommend-multimedia/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-globe"></i>
                    <i class="fas fa-arrow-right"></i>
                    <i class="fas fa-photo-video"></i>
                    <span>Recomendar multimedia desde Internet</span>
                </li>
                <!--
                <li routerLink="/extract-images/{{ courseID }}" routerLinkActive="active" *ngIf="userID == 1">
                    <i class="fas fa-file-pdf"></i>
                    <i class="fas fa-file-powerpoint"></i>
                    <i class="fas fa-arrow-right"></i>
                    <i class="fas fa-images"></i>
                    <span>Extraer imágenes de PDF / PPT</span>
                </li>
                -->
                <li routerLink="/generate-images/{{ courseID }}" routerLinkActive="active" *ngIf="userID == 1">
                    <i class="fas fa-brain"></i>
                    <i class="fas fa-images"></i>
                    <span>Generar imágenes</span>
                </li>
                <li routerLink="/generate-audio/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-play-circle"></i>
                    <span>Generar audio</span>
                </li>
            </ul>
        </li>
        <!--
        <li id="course-actions-course" class="dropdown">
            <i class="fas fa-archive"></i>
            <span>Acciones de curso</span>
            <ul id="course-actions-course-dropdown" class="dropdown-content">
                <li routerLink="/generate-course/{{ courseID }}" routerLinkActive="active">
                    <i class="fas fa-redo-alt"></i>
                    <span>Volver a generar</span>
                </li>
            </ul>
        </li>
        -->
        <li id="course-preview" class="dropdown" *ngIf="!courseHasErrors">
            <i class="fas fa-eye"></i>
            <span>Previsualizar</span>
            <ul id="course-preview-dropdown" class="dropdown-content">
                <li (click)="showCoursePreview('desktop')">
                    <i class="fas fa-desktop"></i>
                    <span>PC</span>
                </li>
                <li (click)="showCoursePreview('mobile')">
                    <i class="fas fa-mobile"></i>
                    <span>Móvil</span>
                </li>
            </ul>
        </li>
        <li id="course-export" class="dropdown">
            <i class="fas fa-external-link-alt"></i>
            <span>Exportar</span>
            <ul id="course-export-dropdown" class="dropdown-content">
                <li (click)="showCourseExport('desktop')" *ngIf="userOrg == 1">
                    <i class="fas fa-desktop"></i>
                    <span>PC</span>
                </li>
                <li (click)="showCourseExport('mobile')" *ngIf="userOrg == 1">
                    <i class="fas fa-mobile"></i>
                    <span>Móvil</span>
                </li>
                <li (click)="showCourseExport('pdf')">
                    <i class="fas fa-file-pdf"></i>
                    <span>PDF</span>
                </li>
                <div id="export-english" *ngIf="userOrg == 1 && courseLanguage == 'english'">
                    <li (click)="showCourseExport('desktop', 'en')">
                        <i class="fas fa-desktop me-2"></i>
                        <i class="english me-2"></i>
                        <span>PC (Inglés)</span>
                    </li>
                    <li (click)="showCourseExport('mobile', 'en')">
                        <i class="fas fa-mobile me-2"></i>
                        <i class="english me-2"></i>
                        <span>Móvil (Inglés)</span>
                    </li>
                    <li (click)="showCourseExport('pdf', 'en')">
                        <i class="fas fa-file-pdf me-2"></i>
                        <i class="english me-2"></i>
                        <span>PDF (Inglés)</span>
                    </li>
                </div>
                <div id="export-chinese" *ngIf="userOrg == 1 && courseLanguage == 'chinese'">
                    <li (click)="showCourseExport('desktop', 'cn')">
                        <i class="fas fa-desktop me-2"></i>
                        <i class="chinese me-2"></i>
                        <span>PC (Chino)</span>
                    </li>
                    <li (click)="showCourseExport('mobile', 'cn')">
                        <i class="fas fa-mobile me-2"></i>
                        <i class="chinese me-2"></i>
                        <span>Móvil (Chino)</span>
                    </li>
                    <li (click)="showCourseExport('pdf', 'cn')">
                        <i class="fas fa-file-pdf me-2"></i>
                        <i class="chinese me-2"></i>
                        <span>PDF (Chino)</span>
                    </li>
                </div>
            </ul>
        </li>
        <li id="course-backup" class="dropdown">
            <i class="fas fa-download"></i>
            <span>Copia de seguridad</span>
            <ul id="course-backup-dropdown" class="dropdown-content">
                <li [swal]="['No implementado', '', 'warning']">
                    <i class="fas fa-download"></i>
                    <span>Descargar copia de seguridad</span>
                </li>
            </ul>
        </li>
        <li id="course-info" class="dropdown">
            <i class="fas fa-info-circle"></i>
            <span>Información</span>
            <ul id="course-info-dropdown" class="dropdown-content">
                <li (click)="showCourseDuration()">
                    <i class="fas fa-clock"></i>
                    <span>Duración del curso</span>
                </li>
            </ul>
        </li>
        <li id="course-report" class="dropdown">
            <i class="fas fa-copy"></i>
            <span>Informes</span>
            <ul id="course-report-dropdown" class="dropdown-content">
                <li (click)="showReport('courseStructureWithoutHeadings')">
                    <i class="fas fa-arrow-right"></i>
                    <!-- <span>Contenidos (Lecciones)</span> -->
                    <span>Estructura del curso (sin enunciados)</span>
                </li>
                <li (click)="showReport('courseStructure')">
                    <i class="fas fa-arrow-right"></i>
                    <!-- <span>Contenidos (Enunciados)</span> -->
                    <span>Estructura del curso</span>
                </li>
                <!--
                <li [swal]="['No implementado', '', 'warning']">
                    <i class="fas fa-arrow-right"></i>
                    <span>Actividades y Evaluaciones</span>
                </li>
                -->
                <li (click)="showReport('courseStructureWithActivities')">
                    <i class="fas fa-arrow-right"></i>
                    <!-- <span>INFORME 1. TODA LA PRÁCTICA</span> -->
                    <span>Estructura del curso (con actividades)</span>
                </li>
                <li (click)="showReport('evaluationsReport')">
                    <i class="fas fa-arrow-right"></i>
                    <!-- <span>INFORME 2. SÓLO EVALUACIONES</span> -->
                    <span>Informe de evaluaciones</span>
                </li>
                <li (click)="showReport('casestudiesReport')">
                    <i class="fas fa-arrow-right"></i>
                    <!-- <span>INFORME 3. SÓLO CASOS PRÁCTICOS</span> -->
                    <span>Informe de casos prácticos</span>
                </li>
                <!--
                <li [swal]="['No implementado', '', 'warning']">
                    <i class="fas fa-arrow-right"></i>
                    <span>INFORME 4. SÓLO TRABAJOS PARTICIPATIVOS</span>
                    <span>Informe de trabajos participativos</span>
                </li>
                -->
                <!--
                <li [swal]="['No implementado', '', 'warning']">
                    <i class="fas fa-arrow-right"></i>
                    <span>Extractor de casos prácticos (solo para uso interno)</span>
                </li>
                -->
                <li (click)="showMultimediaReport(courseID)">
                    <i class="fas fa-photo-video"></i>
                    <span>Informe Multimedia</span>
                </li>
            </ul>
        </li>
        <li id="course-tools" class="dropdown">
            <i class="fas fa-wrench"></i>
            <span>Herramientas</span>
            <ul id="course-tools-dropdown" class="dropdown-content">
                <li (click)="showCheckLinks(courseID)">
                    <i class="fas fa-globe"></i>
                    <span>Revisar enlaces</span>
                </li>
                <li (click)="showNodesTextSearch(courseID)">
                    <i class="fas fa-search"></i>
                    <span>Buscar texto en nodos</span>
                </li>
                <li (click)="showGenerateQuestionsMoodle(courseID)">
                    <i class="fas fa-question"></i>
                    <span>Generar preguntas para Moodle</span>
                </li>
                <li (click)="showCourseLock()" *ngIf="!courseLocked">
                    <i class="fa fa-lock"></i>
                    <span>Terminar edición y solicitar instalación</span>
                </li>
                <li (click)="showCourseLock()" *ngIf="courseLocked && userID == 1">
                    <i class="fa fa-unlock"></i>
                    <span>Desbloquear curso</span>
                </li>
                <li (click)="requestUnlock()" *ngIf="courseLocked">
                    <i class="fa fa-bell"></i>
                    <span>Solicitar permiso para editar</span>
                </li>
                <!--
                <li (click)="showCheckErrors()">
                    <i class="fas fa-times"></i>
                    <span>Revisar errores</span>
                </li>
                -->
            </ul>
        </li>
    </ul>

    <div id="tree-open-close-buttons" *ngIf="!courseLocked">
        <button class="btn btn-primary me-3" (click)="jstreeOpenAll()">
            <i class="fa fa-folder-open"></i>
            <span>Abrir todo</span>
        </button>
        <button class="btn btn-primary me-3" (click)="jstreeCloseAll()">
            <i class="fa fa-folder"></i>
            <span>Cerrar todo</span>
        </button>
    </div>
    
    <hr>

    <div id="course-container-lower">

        <div id="course-tree" resizable>
            <div id="jstree" *ngIf="!courseLocked"></div>
            <div id="no-tree" *ngIf="courseLocked">
                <p>El curso está bloqueado.</p>
                <p>Para ver los contenidos, utilice la opción "Previsualizar".</p>
                <p>También puedes ver la estructura mediante "Informes".</p>
            </div>
        </div>

        <div id="course-content">
            <div id="unit-container" class="me-4" *ngIf="unitInfo">
                <unit-info [id]="unitID" [course]="courseID" [multitransl]="courseMultitransl" [transl]="courseCurrentTransl"></unit-info>
            </div>

            <div id="lesson-container" class="me-4" *ngIf="lessonInfo">
                <lesson-info [id]="lessonID" [course]="courseID" [multitransl]="courseMultitransl" [transl]="courseCurrentTransl"></lesson-info>
            </div>

            <div id="heading-container" class="me-4" *ngIf="heading">
                <heading [id]="headingID" [type]="headingType" [course]="courseID" [lesson]="lessonID" [multitransl]="courseMultitransl" [transl]="courseCurrentTransl"></heading>
            </div>

            <div id="summary-container" class="me-4" *ngIf="summary">
                <heading [id]="summaryID" [type]="'summary'" [multitransl]="courseMultitransl" [transl]="courseCurrentTransl"></heading>
            </div>

            <div id="lesson-multimedia" *ngIf="multimedia">
                <multimedia [courseID]="courseID" [parentType]="'lesson'" [parentID]="lessonID"></multimedia>
            </div>

            <div id="lesson-files" *ngIf="files">
                <files [courseID]="courseID" [parentType]="'lesson'" [parentID]="lessonID"></files>
            </div>

            <div id="lesson-tables" *ngIf="tables">
                <tables [courseID]="courseID" [parentType]="'lesson'" [parentID]="lessonID"></tables>
            </div>
            
            <div id="lesson-activity-test" *ngIf="activityTest">
                <activity-test [id]="activityTestID" [type]="activityTestType" [course]="courseID" [multitransl]="courseMultitransl" [transl]="courseCurrentTransl"></activity-test>
            </div>
    
            <div id="unit-glossary" *ngIf="glossary">
                <glossary [id]="glossaryID" [course]="courseID" [category]="courseCategory" [multitransl]="courseMultitransl" [transl]="courseCurrentTransl"></glossary>
            </div>

            <div id="course-objectives" *ngIf="objectives">
                <objectives [id]="objectivesID" [multitransl]="courseMultitransl" [transl]="courseCurrentTransl"></objectives>
            </div>

            <div id="course-preview-container" *ngIf="coursePreview">
                <export-course [course]="courseID" [name]="courseName" [type]="courseExportType" [language]="courseExportLanguage" [translations]="courseTranslations" [previewOnly]="true" (onClose)="cancelCourseExport()"></export-course>
            </div>

            <div id="course-export-container" *ngIf="courseExport">
                <export-course [course]="courseID" [name]="courseName" [type]="courseExportType" [language]="courseExportLanguage" [translations]="courseTranslations" (onClose)="cancelCourseExport()"></export-course>
            </div>

            <div id="course-backup" *ngIf="courseBackup"></div>

            <div id="course-duration" *ngIf="courseDuration">
                <course-duration [course]="courseID"></course-duration>
            </div>

            <div id="report-container" *ngIf="report">
                <report [type]="reportType" [course]="courseID" [name]="courseNameView" (onClose)="cancelReport()"></report>
            </div>

            <div id="move-unit-container" *ngIf="moveUnit">
                <move-unit [courseId]="courseID" [unitId]="moveUnitId" [unitName]="moveUnitName" [destinationCategoryId]="courseCategory" (onClose)="cancelMoveUnit()"></move-unit>
            </div>

            <div id="check-links-container" *ngIf="checkLinks">
                <check-links [course]="courseID" (onClose)="cancelCheckLinks()"></check-links>
            </div>

            <div id="nodes-text-search-container" *ngIf="nodesTextSearch">
                <nodes-text-search [course]="courseID" (onClose)="cancelNodesTextSearch()"></nodes-text-search>
            </div>

            <div id="multimedia-report-container" *ngIf="multimediaReport">
                <multimedia-report [course]="courseID" (onClose)="cancelMultimediaReport()"></multimedia-report>
            </div>

            <div id="course-lock-container" *ngIf="courseLock">
                <course-lock [course]="courseID" [locked]="courseLocked" (onClose)="hideAll()"></course-lock>
            </div>

            <div id="generate-questions-moodle-container" *ngIf="generateQuestionsMoodle">
                <generate-questions-moodle [course]="courseID" (onClose)="hideAll()"></generate-questions-moodle>
            </div>
            
        </div>

    </div>
    
</div>

<div id="nav-link">
    <hr>
    <a routerLink="/my-categories-courses" routerLinkActive="active">
        <i class="fas fa-arrow-circle-left"></i>
        <span>Volver a la lista de cursos</span>
    </a>
</div>

<dialog id="generate-unit-dialog">
    <generate-unit [unitID]="generateUnitID" [unitName]="generateUnitName" [courseID]="courseID" [courseName]="courseNameView" [dialog]="true"></generate-unit>
</dialog>

<dialog #courseFormDialog id="course-form-dialog">
    <ng-container *ngIf="courseFormShow">
        <form method="dialog">
            <button class="btn-close float-end" (click)="closeCourseForm()"></button>
        </form>
        <course-form [id]="courseID" [name]="courseNameView" [hours]="courseHours" [category]="courseCategory" [translations]="courseTranslations" [edit]="true" [dialog]="true"></course-form>
        <form method="dialog">
            <button class="btn btn-danger mx-3" (click)="closeCourseForm()">
                <i class="fas fa-times"></i>
                <span>Cerrar</span>
            </button>
        </form>
    </ng-container>
</dialog>